/* eslint-disable import/order,radix,no-throw-literal */
import { getLogger } from '@jitsi/logger';

const logger = getLogger(__filename);

import { getNextSchedule, getPresence, setPresence } from './actions';
import Presence, { PRESENCE_MESSAGE_DND, PRESENCE_STATUS_DND } from './Presence';

const STATUS_TIMEOUT_SEC_DEFAULT = 60 * 60; // 1 hour in seconds

/**
 * Logic to change presence status to dnd when user in conference and
 * revert it back when user leave conference
 */
export default class PbxUserPresence {

    /**
     */
    constructor() {
        this._prevPresence = null;
        this._dndPresence = new Presence(
            PRESENCE_STATUS_DND,
            PRESENCE_MESSAGE_DND,
            null
        );
    }

    /**
     *
     */
    setInConference() {
        // If no schedule setup 1 hour
        let statusTimeoutSec = STATUS_TIMEOUT_SEC_DEFAULT;

        getNextSchedule().then(schedule => {
            const { start: scheduleStart, end: scheduleEnd } = schedule.result ?? {};

            // All values in seconds
            const intervalInSeconds = value => parseInt(value - (Date.now() / 1000));
            const hoursToSeconds = value => value * 60 * 60;

            const beginFromNow = intervalInSeconds(scheduleStart);
            const endFromNow = intervalInSeconds(scheduleEnd);

            if (endFromNow > 0 && beginFromNow > hoursToSeconds(-1) && beginFromNow < hoursToSeconds(1)) {
                // Probably, next request will update until time not immediately - give it 1 sec reserve
                statusTimeoutSec = endFromNow + 1;
            }
        })
            .finally(() => {
                getPresence().then(presence => {

                    logger.warn('presence', presence);
                    if (presence.isDnd()) {
                        throw 'Presence already dnd';
                    }
                    if (this._prevPresence) {
                        throw 'Logic error - already has not reverted presence';
                    }

                    this._prevPresence = presence;

                    // Update dnd until date with calculated above
                    const until = new Date();

                    until.setSeconds(until.getSeconds() + statusTimeoutSec);
                    this._dndPresence.until = until;
                    setPresence(this._dndPresence);

                    // Continue dnd status
                    this.watchAndContinueDndStatus(statusTimeoutSec);

                })
                    .catch(e => {
                        logger.warn('unable to update collaboration status:', e);
                    });
            });
    }

    /**
     *
     * @param statusTimeoutSec
     */
    watchAndContinueDndStatus(statusTimeoutSec) {
        const c = setTimeout(() => {
            if (APP.conference.terminated) {
                return;
            }

            // Time gone but conference still in progress
            // Add one more hour
            const until = new Date();

            until.setSeconds(until.getSeconds() + STATUS_TIMEOUT_SEC_DEFAULT);
            this._dndPresence.until = until;
            setPresence(this._dndPresence);

            // Setup next watch if conference not ended
            this.watchAndContinueDndStatus(STATUS_TIMEOUT_SEC_DEFAULT);
            clearTimeout(c);
        }, statusTimeoutSec * 1000 > 0x7FFFFFFF ? 0x7FFFFFFF : statusTimeoutSec * 1000);
    }

    /**
     *
     */
    revert() {
        if (this._prevPresence) {
            setPresence(this._prevPresence).catch(e => {
                logger.error('unable to revert pbx presence', e);
            });
            this._prevPresence = null;
        }
    }

    /**
     *
     */
    onGotFocusInIOS() {
        // While conference active
        if (!APP.conference.terminated && !this._prosessFocus) {
            // Strange behaviour on iOS Safari focus triggers twice
            this._prosessFocus = true;
            getPresence().then(presence => {
                // Ensure that status will changed to not dnd after iOS app got focus
                if (!presence.isDnd()) {
                    return setPresence(this._dndPresence);
                }
            })
                .finally(() => {
                    this._prosessFocus = false;
                });
        }
    }

}
